import { supabase } from '@/core/database/supabase';
import type { ConstructionBoq, BoqFilters } from '../types/construction-boq.types';

export const ConstructionBoqService = {
  async getBoqs(companyId: string, filters: BoqFilters = {}) {
    let query = supabase
      .from('construction_boqs')
      .select(`
        *,
        project:projects(id, name),
        contract:construction_contracts(id, contract_code, contract_name)
      `, { count: 'exact' })
      .eq('company_id', companyId);

    if (filters.status && filters.status !== 'all') query = query.eq('status_code', filters.status);
    if (filters.projectId) query = query.eq('project_id', filters.projectId);
    if (filters.contractId) query = query.eq('contract_id', filters.contractId);
    if (filters.search) {
      query = query.or(`boq_name.ilike.%${filters.search}%,boq_code.ilike.%${filters.search}%`);
    }

    query = query.order('created_at', { ascending: false });

    const { data, error, count } = await query;
    if (error) throw error;
    return { data: data as ConstructionBoq[], total: count || 0 };
  },

  async getBoqDetail(id: string) {
    const { data, error } = await supabase
      .from('construction_boqs')
      .select(`
        *,
        project:projects(id, name),
        contract:construction_contracts(id, contract_code, contract_name)
      `)
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as ConstructionBoq;
  },

  async createBoq(data: Partial<ConstructionBoq>) {
    const { data: result, error } = await supabase
      .from('construction_boqs')
      .insert([data])
      .select()
      .single();

    if (error) throw error;
    return result as ConstructionBoq;
  },

  async updateBoq(id: string, updates: Partial<ConstructionBoq>) {
    const { error } = await supabase
      .from('construction_boqs')
      .update(updates)
      .eq('id', id);

    if (error) throw error;
  },

  async deleteBoq(id: string) {
    const { error } = await supabase
      .from('construction_boqs')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
